import { SortingState } from '@tanstack/react-table';
import { useQuery } from 'react-query';
import { network } from 'services/network';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { ISingleSmallCardResponse } from 'api/queries/getListFilteredCards.query';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

const queryFn = (params: QueryParams) => {
    return network.post('api/bo/getDelayDriver', params).then((response) => {
        return response.data;
    });
};
export const useQueryActivities = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryFn: () => queryFn(params),
        queryKey: ['futurePotentialActivities', params],
        enabled: params?.id.filter(Boolean).length > 0,
    });
};

interface QueryParams extends NarrativeRequest {
    id: number[];
    paging: {
        page: number;
        size: number;
    };
    filter: {
        filters: IFilter[];
    };
    sortingRequestList: SortingState;
}

interface QueryResponse {
    delayDrivers: IActivitiesData[];
    info: IToolTip;
    numOfPages: number;
    numOfRows: number;
    startDate: number;
    finishDate: number;
}

export interface IActivitiesData {
    activityId: string;
    activityName: string;
    activityType: string;
    actualDuration: number;
    actualFinishDate: number;
    actualStartDate: number;
    baselineFinishDate: number;
    baselineStartDate: number;
    cardBoardViewResponse: ISingleSmallCardResponse;
    completedDuration: number;
    criticalPath: boolean;
    criticalityScore: number;
    currentFinishDate: number;
    currentStartDate: number;
    delayDriver: boolean;
    durationOverun: number;
    float: null | number;
    grandParentName: string;
    numOfPredecessors: number;
    numOfSuccessors: number;
    overrunDays: number;
    overrunPercent: number;
    parentName: string;
    plannedDuration: number;
    plannedFinishDate: number;
    plannedStartDate: number;
    projectMonthFinish: number;
    projectMonthStart: number;
    projectWeekFinish: number;
    projectWeekStart: number;
    remainingDuration: number;
    taskVersionHashCode: string;
}

export type ITopOverdueData = IActivitiesData;
